module.exports = __webpack_public_path__ + "img/component_function.d82f4529.png";